/* Returns a unique key for lists in React */
const uid = () => {
	return parseInt(Math.random() * 100000);
};

export { uid };
